import { t } from 'i18next'
import React from 'react'
import { any, async, fromJSX, StandardLocalWidget, Updater } from 'widgets-for-react'
import { TextBlockWidget } from '../../../cms/blocks/widgets/textBlock.gen'
import {
  vacancyFooterButtonFormDatalayer,
  vacancyFormFormDatalayer,
  vacancyHeaderButtonFormDatalayer
} from '../../../datalayer'
import { Locale } from '../../../drupal/types_and_parser/extra_types.mod'
import { Form, SuccessForm } from '../../../form'
import { FormState } from '../../../form/types'
import { textBlockClasses } from '../../blocks/style.mod'
import { translatedCareersSlug, translatedCareersTitle } from '../../overview/utils'
import { Breadcrumbs } from '../../templates/breadcrumbs.mod'
import { NotFoundPage } from '../../templates/error_page.mod'
import HeroVisual, { getVacancyImage } from '../../templates/heroVisual'
import { getLangFromUrl, oldSites } from '../../utils/history.mod'
import { Loader } from '../../utils/loader'
import { getDepartment } from '../utils'
import { Vacancy, VacancyDetailState } from './state'
var recruitmentProcessJson = require('../../../../../wwwroot/recruitmentProcess.json')

export const vacancyDetailWidget =
  (success: boolean, language: Locale): StandardLocalWidget<VacancyDetailState> =>
  (state) => {
    const vacancy = state.get_vacancy && state.get_vacancy.kind == 'loaded' ? state.get_vacancy.value : undefined

    const careersSlug = translatedCareersSlug[language]
    const careersTitle = translatedCareersTitle[language]

    return any([
      async(state.get_vacancy).map((updater) => (state: VacancyDetailState): VacancyDetailState => {
        const newState = { ...state, get_vacancy: updater(state.get_vacancy) }
        const vacancy = newState.get_vacancy
        if (vacancy.kind == 'loaded') newState.form.custom_context.Kind = vacancy.value.Kind
        return newState
      }),
      fromJSX((setState) => (
        <div className="main main--vacancy">
          <div className="main__inner">
            <div className="page">
              <div className="page__inner">
                <div className="page__content">
                  {state.get_vacancy.kind == 'loaded' ? (
                    vacancy.Id == null ? (
                      <NotFoundPage />
                    ) : success || state.current_view == 'apply-form' ? (
                      <>
                        <header className="pageheader no-image">
                          <div className="pageheader__inner">
                            <div className="pageheader__content container container--m">
                              <div className="pageheader__message">
                                <div className="pageheader__header">
                                  <h1 className="pageheader__title">{vacancy.Name}</h1>
                                </div>
                              </div>
                              <div className="pageheader__visual no-image" />
                            </div>
                          </div>
                        </header>
                        {success && (
                          <div className="block block--form">
                            <div className="block__inner container container--m grid--block">
                              <div className="block__content">
                                <a className="link link--back" href={window.location.href.replace('/success/', '')}>
                                  <span>{success ? t('Vacancy:return_to_vacancy') : t(`Vacancy:all_vacancies`)}</span>
                                  <svg className="link__icon" height="14" width="18">
                                    <use xlinkHref="#icon--arrow" />
                                  </svg>
                                </a>

                                <h2 className="block__title">
                                  {t('Vacancy:application_for')} {vacancy.Name}
                                </h2>
                                {SuccessForm(state.form).run((updater) =>
                                  setState((state): VacancyDetailState => {
                                    const newFormState: FormState = updater(state.form)
                                    if (newFormState.form_submission_logic.kind == 'loaded')
                                      vacancyFormFormDatalayer('submit_application')
                                    return { ...state, form: newFormState }
                                  })
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <header className="pageheader no-image pageheader--flat">
                          <div className="pageheader__inner">
                            <div className="pageheader__content container container--m">
                              <div className="pageheader__message">
                                <div className="pageheader__header">
                                  <h1 className="pageheader__title">{vacancy.Name}</h1>
                                  {/* <div className={"pageheader__intro"} dangerouslySetInnerHTML={{ __html: vacancy.Description }} /> */}
                                </div>
                              </div>

                              <HeroVisual
                                hasCMSImg={false}
                                hasVacancyImg={true}
                                vacancyImage={getVacancyImage(getDepartment(vacancy.Department))}
                              />
                            </div>
                          </div>

                          <div className="container vacancy-search-bar__inner container--m">
                            <div className="pageheader__search-bar grid--gutter">
                              <div className="pageheader__info">
                                <ul className="pageheader__list">
                                  {vacancy.City && <InfoItem title={vacancy.City} icon="pin-new" height={24} width={24} />}
                                  {vacancy.IsFulltime ? (
                                    <InfoItem title={t('Vacancy:fulltime')} icon="clock-new" height={24} width={24} />
                                  ) : (
                                    <InfoItem title={t('Vacancy:parttime')} icon="clock-new" height={24} width={24} />
                                  )}
                                  {vacancy.Department && (
                                    <InfoItem
                                      title={t(
                                        `search:tag_${getDepartment(vacancy.Department)
                                          ?.replace('&', '_')
                                          .replace(',', '_')
                                          .replace('-', '_')
                                          .split(/\s/)
                                          .join('')
                                          .toLowerCase()}`
                                      )}
                                      icon="department-new"
                                      height={24}
                                      width={24}
                                    />
                                  )}
                                </ul>
                              </div>
                              <button
                                className="button button--primary"
                                onClick={() => {
                                  setState((state): VacancyDetailState => ({ ...state, current_view: 'apply-form' }))
                                  vacancyHeaderButtonFormDatalayer(t('Vacancy:apply_now'))
                                }}
                              >
                                <span> {t('Vacancy:apply_now')} </span>
                              </button>
                            </div>
                          </div>
                        </header>
                        <div className="block block--form">
                          <div className="block__inner container container--m grid--block">
                            <div className="block__content">
                              <a
                                className="link link--back"
                                href={`/${getLangFromUrl()}/${translatedCareersSlug[language]}/vacancies`}
                              >
                                <span>{t(`Vacancy:all_vacancies`)}</span>
                                <svg className="link__icon" height="18" width="18">
                                  <use xlinkHref="#icon--arrow-left" />
                                </svg>
                              </a>
                            </div>
                          </div>
                        </div>
                        <VacancyC vacancy={state.get_vacancy.value} setState={setState} />
                      </>
                    )
                  ) : (
                    <Loader />
                  )}

                  {!success &&
                    state.get_vacancy.kind == 'loaded' &&
                    fromJSX<Updater<VacancyDetailState>>((setState) => {
                      if (state.current_view == 'apply-form') vacancyFormFormDatalayer('start_application')
                      return (
                        <section className="block block--form">
                          <div className="block__inner container container--m grid--block">
                            <div className="block__content">
                              {state.current_view == 'apply-form' && (
                                <>
                                  <a
                                    className="link link--back"
                                    onClick={() =>
                                      setState((s): VacancyDetailState => ({ ...s, current_view: 'vacancy-detail' }))
                                    }
                                  >
                                    <span>{t('Vacancy:return_to_vacancy')}</span>
                                    <svg className="link__icon" height="18" width="18">
                                      <use xlinkHref="#icon--arrow-left" />
                                    </svg>
                                  </a>
                                  <h2 className="block__title">
                                    {t('Vacancy:application_for')} {vacancy.Name}
                                  </h2>
                                </>
                              )}
                              {state.current_view == 'apply-form' &&
                                Form(state.form)
                                  .map<Updater<VacancyDetailState>>((updater) => (state): VacancyDetailState => {
                                    const newFormState: FormState = updater(state.form)
                                    if (newFormState.form_submission_logic.kind == 'loaded')
                                      vacancyFormFormDatalayer('submit_application')
                                    return { ...state, form: newFormState }
                                  })
                                  .run(setState)}
                            </div>
                          </div>
                        </section>
                      )
                    }).run(setState)}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))
    ])
  }

const VacancyC = ({
  vacancy,
  setState
}: {
  vacancy: Vacancy
  setState: (_: Updater<VacancyDetailState>) => void
}): JSX.Element => (
  <>
    {titledBodyWidget('', vacancy.Description, 0).run(() => {})}
    {/* titledBodyWidget(i18next.t('Vacancy.JobRequirements'), vacancy.ToVacancy.CRVacancy.Requirements)*/}
    <RecruitmentProcessBlock job={vacancy.Department} language={vacancy.Language} />
    <section className="block block--apply apply">
      <div className="block__inner container container--m grid--block">
        <div className="block__content">
          <h2 className="apply__title title--l">{t('Vacancy:apply_now')}</h2>
          <div className="apply__message">
            <p>{t('Vacancy:apply_now_message')}</p>
          </div>
          <div className="apply__buttons">
            <button
              className="button button--primary"
              onClick={() => {
                setState((state): VacancyDetailState => ({ ...state, current_view: 'apply-form' }))
                vacancyFooterButtonFormDatalayer(t('Vacancy:apply_now'))
              }}
            >
              {t('Vacancy:apply_now')}
            </button>
            {/* <a
                      className="button button--secondary"
                      href={`mailto:?subject=&body= Remember this vacancy.%0D%0A%0D%0A ${vacancy.Name} - link: ${window.location.href}`} >
                      {t("Vacancy:contact_recruiter")}
                    </a> */}
          </div>
        </div>
      </div>
    </section>
  </>
)

const titledBodyWidget = (title: string, text: string, index: number) => {
  let text1 = (text || '')
    // .replace(/style="font-family: arial , helvetica , sans-serif;font-size: 10.0pt;"/g, '')
    // .replace(/style="font-family: arial, helvetica, sans-serif; font-size: 10pt;"/g, '')
    // .replace(/style="display:none"/g, '')
    // .replace(/style="font-family: arial , helvetica , sans-serif; font-size: 10.0pt;"/g, '')
    // .replace(/style="font-family: arial , helvetica , sans-serif; font-size: 10.0pt";/g, '')
    // .replace(/style="style="font-size:8.5pt;font-family:&quot;Arial&quot;,sans-serif;color:black;background:white";/g, '')
    // .replace(/font-size: 8.5pt; font-family: Arial, sans-serif; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;/g, "")
    .replace(/\s?\w*=".*?"\s?/g, '')
    // .replace(/\<span\>/g, "<p>")
    // .replace(/\<span \>/g, "<p>")
    // .replace(/\<\/span\>/g, "</p>")
    .replace(/arial,helvetica,sans-serif/g, '')
    .replace(/size="2"/g, '')
    .replace(/font-family: ; font-size: 10pt;/g, '')
    .replace(/font-family:/g, 'font-famil:')
    .replace(/font-size:/g, 'font-siz:')
    .replace(/background-image:/g, 'background-imag:')
    .replace(/<br data-mce-bogus="1">/g, '')
    .replace(/&nbsp;/g, ' ')
  // can be used for testing:
  // console.log(text1)

  return TextBlockWidget(
    {
      title: title,
      text: text1,
      index: index,
      link_type: false
    },
    { style: textBlockClasses }
  )(null)
}

const RecruitmentProcessBlock = ({ job, language }: { job: string; language: string }): JSX.Element => {
  let recruitmentProcess = getRecruitmentProcess(job)

  let corporateSite = oldSites.getIn(['global']).replace('/en/', '')
  let isCorporateSite =
    window.location.origin?.startsWith(corporateSite) ||
    window.location.origin?.startsWith('http://localhost:5000/en') || // testing locally
    window.location.origin?.startsWith('https://refresco-refresco.acceptatie.viddadigital.com') //  acceptance

  let lng = isCorporateSite ? 'en' : language
  return (
    recruitmentProcess != undefined && (
      <section className="block block--recruit">
        <div className="block__inner container container--m grid--gutter">
          <h2 className="block__title title--s">{t(`RecruitmentProcess:title`)}</h2>
          <ul className="block__list">
            {recruitmentProcess.steps.map((steps, i) => (
              <li className="block__item item" key={`classforRecruitmentProcess-selector-${i + 1}`}>
                <div className="item__inner">
                  <div className="item__number">
                    <span className="item__label">{i + 1}</span>
                  </div>
                  <p className="item__text">
                    {i + 1 === 1
                      ? t(`RecruitmentProcess:stepOne`)
                      : i + 1 === 2
                      ? t(`RecruitmentProcess:stepTwo`)
                      : t(`RecruitmentProcess:stepThree`)}
                  </p>
                </div>
              </li>
            ))}
          </ul>
          <p className="block__disclaimer">{t(`RecruitmentProcess:disclaimerText`)}</p>
        </div>
      </section>
    )
  )
}

export type RecruitmentSteps<T extends string> = { [p in T]: string }

export type RecruitmentProcess = {
  job: string
  steps?: RecruitmentSteps<'en' | 'uk' | 'nl' | 'fr' | 'pl' | 'de' | 'es' | 'fi' | 'it'>[]
}

export const getRecruitmentProcessData = (): RecruitmentProcess[] => recruitmentProcessJson

export const getRecruitmentProcess = (job: string): RecruitmentProcess => {
  let recruitmentProcess = getRecruitmentProcessData()
  let selectedRecruitmentProcess = recruitmentProcess.find((f) => f.job == job)
  if (selectedRecruitmentProcess == undefined) {
    selectedRecruitmentProcess = recruitmentProcess.find((f) => f.job == 'Default')
  }
  return selectedRecruitmentProcess
}

const InfoItem = ({
  title,
  icon,
  height,
  width
}: {
  title: string
  icon: string
  height: number
  width: number
}): JSX.Element => (
  <li className="pageheader__item">
    <span>{title}</span>
    <svg className="pageheader__icon" aria-hidden="true" height={height} width={width}>
      <use xlinkHref={`#icon--${icon}`} />
    </svg>
  </li>
)
